import { Box, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import MzButton from "@markaaz/ui/MzButton";
import MzAlert from "@markaaz/ui/MzAlert";
import MzCheckbox from "@markaaz/ui/MzCheckbox";
import DataFieldTable from "./DataFieldTable";

const sx = {
  formControl: {
    marginLeft: "0px",
    color: "darkBlue.c70"
  },

  wrap: {
    display: "flex",
    maxWidth: "980px",
    padding: "20px",
    flexDirection: "column",
    alignItems: "flexStart",
    gap: "10px",
    backgroundColor: "common.white",
    borderRadius: "8px"
  },
  section: {
    display: "flex",
    alignItems: "center",
    gap: "20px"
  },

  header: {
    color: "blue.c100"
  },
  checkbox: (theme) => {
    return {
      "& .MuiTypography-root": {
        ...theme.typography.body1,
        paddingLeft: "10px"
      },
      "& .MuiCheckbox-root": {
        color: (theme) => theme.palette.darkBlue.c50
      },
      "& .Mui-checked": {
        color: (theme) => theme.palette.blue.c100
      },
      paddingLeft: "20px"
    };
  }
};

export default function FieldMapping({
  loading,
  fieldMappingRows,
  hasHeaderRow,
  showAlert,
  onFieldChange,
  onUpdate,
  onHeaderRowChange,
  onReset,
  onClearAll,
  onAlertClose
}) {
  const midIndex = Math.floor(fieldMappingRows.length / 2);
  const fieldMappingRowsLeft = fieldMappingRows.slice(0, midIndex);
  const fieldMappingRowsRight = fieldMappingRows.slice(midIndex);
  return (
    <Box>
      <Box mt={18}>
        <Typography variant="h6" mb={4}>
          Field Mapping
        </Typography>
        <Typography variant="body2" mb={4} maxWidth={750}>
          Map data fields to your test file columns. Make sure there are no column duplicates, all required fields are
          selected, and you have cleared unused columns. Default mapping is used if no changes are made.
        </Typography>
      </Box>
      <Box sx={sx.wrap} mt={10} mb={10}>
        <Typography variant="body1M" sx={sx.header}>
          Header Row
        </Typography>
        <MzCheckbox
          label="Select if file contains a header row"
          sx={sx.checkbox}
          name="isHeaderEnabled"
          checked={hasHeaderRow}
          onChange={onHeaderRowChange}
        />
      </Box>
      <Box>
        <Stack direction="row " gap={"1px"}>
          <DataFieldTable rows={fieldMappingRowsLeft} onChange={onFieldChange} onClear={onClearAll} />
          <DataFieldTable rows={fieldMappingRowsRight} hasClearAll onChange={onFieldChange} onClear={onClearAll} />
        </Stack>
      </Box>
      <Box sx={sx.section}>
        <MzButton size="large" variant="outlined" color="secondary" onClick={onReset} sx={{ minWidth: "280px" }}>
          Reset to Last Saved Mapping
        </MzButton>

        <MzButton size="large" variant="contained" onClick={onUpdate} loading={loading}>
          Save Field Mapping
        </MzButton>

        {showAlert.message && (
          <MzAlert
            sx={{ maxWidth: "600px", alignItems: "center" }}
            severity={showAlert.type === "success" ? "success" : "error"}
            onClose={() => {
              onAlertClose("fm");
            }}
          >
            {showAlert.message}
          </MzAlert>
        )}
      </Box>
    </Box>
  );
}
